module.exports = __webpack_public_path__ + "img/mai-tai.f3418c14.jpg";